import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Stack,
  Checkbox,
  ListItemText
} from '@mui/material';
import { useState, useEffect } from 'react';

function FilterDialog({ 
  open, 
  onClose, 
  onApply, 
  filters, 
  activeFilters,
  title = "Filtres"
}) {
  const [localFilters, setLocalFilters] = useState(activeFilters);

  useEffect(() => {
    setLocalFilters(activeFilters);
  }, [activeFilters]);

  const handleChange = (filterKey, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  };

  const handleMultiSelect = (filterKey, value) => {
    setLocalFilters(prev => ({
      ...prev,
      [filterKey]: typeof value === 'string' ? value.split(',') : value
    }));
  };

  const handleApply = () => {
    onApply(localFilters);
    onClose();
  };

  const handleReset = () => {
    const emptyFilters = Object.keys(filters).reduce((acc, key) => {
      acc[key] = filters[key].type === 'select' ? [] : '';
      return acc;
    }, {});
    setLocalFilters(emptyFilters);
    onApply(emptyFilters);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          {Object.entries(filters).map(([key, filterData]) => {
            if (filterData.type === 'text') {
              return (
                <TextField
                  key={key}
                  label={filterData.label}
                  value={localFilters[key] || ''}
                  onChange={(e) => handleChange(key, e.target.value)}
                  fullWidth
                />
              );
            } else if (filterData.type === 'date') {
              return (
                <TextField
                  key={key}
                  label={filterData.label}
                  type="date"
                  value={localFilters[key] || ''}
                  onChange={(e) => handleChange(key, e.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              );
            } else if (filterData.type === 'select') {
              return (
                <FormControl key={key} fullWidth>
                  <InputLabel>{filterData.label}</InputLabel>
                  <Select
                    multiple={filterData.multiple}
                    value={localFilters[key] || (filterData.multiple ? [] : '')}
                    onChange={(e) => {
                      const value = filterData.multiple ? e.target.value : [e.target.value];
                      handleMultiSelect(key, value);
                    }}
                    label={filterData.label}
                    renderValue={(selected) => selected.join(', ')}
                  >
                    {filterData.options.map((option) => (
                      <MenuItem key={option} value={option}>
                        <Checkbox checked={(localFilters[key] || []).indexOf(option) > -1} />
                        <ListItemText primary={option} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              );
            }
            return null;
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReset} color="error">
          Réinitialiser
        </Button>
        <Button onClick={onClose}>
          Annuler
        </Button>
        <Button 
          onClick={handleApply}
          variant="contained"
          color="primary"
        >
          Appliquer
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default FilterDialog; 